import React from 'react';
import { Box, Typography, Button, Container, Paper } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/dashboard');
  };

  return (
    <Container maxWidth="md" sx={{ mt: 8, mb: 8 }}>
      <Paper
        elevation={3}
        sx={{
          p: 6,
          textAlign: 'center',
          borderRadius: 3
        }}
      >
        <Box sx={{ mb: 3 }}>
          <Typography
            variant="h1"
            component="h1"
            sx={{
              fontSize: { xs: '6rem', sm: '8rem' },
              fontWeight: 900,
              color: 'primary.main',
              mb: 2
            }}
          >
            404
          </Typography>
          <SearchOffIcon
            sx={{
              fontSize: 60,
              color: 'text.secondary',
              mb: 2
            }}
          />
        </Box>

        <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 700, mb: 2 }}>
          Página no encontrada
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 500, mx: 'auto' }}>
          Lo sentimos, la página que estás buscando no existe o ha sido movida.
          Por favor, verifica la URL o regresa al inicio.
        </Typography>

        <Button
          variant="contained"
          startIcon={<HomeIcon />}
          onClick={handleGoHome}
          size="large"
          sx={{ px: 4 }}
        >
          Volver al Dashboard
        </Button>
      </Paper>
    </Container>
  );
};

export default NotFound;
